var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icp"},[_c('a',{attrs:{"target":"_blank","href":_vm.icpUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }